import Vue from 'vue'
import Status from '../../components/Status/Status.vue'
import Card from '../../components/CardForContent/CardForContent.vue'
export default Vue.extend({
    name: "WihdrawalTable",
    components: {
        Status,
        Card
    },
    data() {
        return {
            withdrawals: [
                {
                    date: '2021-02-18',
                    amount: 79.20,
                    wallet: 'Tapmixer Balance',
                    status: "pending",
                    id: 0
                },
                {
                    date: '2021-02-18',
                    amount: 79.20,
                    wallet: 'Tapmixer Balance',
                    status: "paid",
                    id: 1
                },
                {
                    date: '2021-02-18',
                    amount: 79.20,
                    wallet: 'Tapmixer Balance',
                    status: "declined",
                    id: 2
                },
            ]
        }
    }
})